var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from "@ember/service";
import MedicModel from "core/models/medic";
import SemeiaSessionService from "core/services/session";
import { Ability } from "ember-can";

/**
 * Classic Ember class is used there because ability overload in parog does not
 * otherwise. The bug is not completely identified though.
 *
 * Note that Ability properties must be computed properties.
 * https://github.com/minutebase/ember-can/issues/83
 */
let MedicAbility = (_class = class MedicAbility extends Ability {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  canCreate(medicToCreate) {
    // Make sure a medic is logged in
    const creatorRole = this.session.medic?.role;
    if (!creatorRole) return false;

    // Make sure the logged in medic's role has some creatableRoles
    const creatableRoles = this.creatableRoles[creatorRole];
    if (!creatableRoles) return false;

    // if no model was passed to `canCreate`, then OK, the logged in medic CAN create
    if (!medicToCreate) return true;

    // if a model was passed to `canCreate`, make sure the creatableRoles roles contain this medic's role
    return creatableRoles.includes(medicToCreate.role);
  }
  get creatableRoles() {
    if (this.session.medic?.therapeuticalArea?.id == "rhumato") return {
      doctor: ["doctor", "nurse"],
      nurse: ["nurse"]
    };
    return {
      doctor: ["doctor", "nurse", "medical_secretary"],
      nurse_lead: ["nurse", "medical_secretary"],
      nurse: ["nurse", "medical_secretary"],
      medical_secretary: ["medical_secretary"]
    };
  }
  get canList() {
    return this.session.medic;
  }
  get canEdit() {
    return this.session.medic && this.session.medic.role === "doctor";
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MedicAbility as default };